export const QTD_DEPENDENTES_ENUM = {
    um: 1,
    dois: 2,
    tres: 3,
    quatro: 4,
    cinco: 5,
    sete: 7,
    nove: 9,
    dez: 10
};

export const IDADE_ENUM = {
    sessentaCinco: 65,
    setentaSeis: 66
};

const verificaSeJaPossuiParentescoSelecionado = (dependentes, values) => {
    const seq = values.Seq;
    const parentesco = values.Parentesco;
    const parentescosQuePodemSerMaisQueUm = ['5', '50', '03', '07', '10006', '10016', '22', '12', '20', '19', '24', '32'];

    if (!parentesco) {
        return false;
    }

    if (parentescosQuePodemSerMaisQueUm.includes(parentesco.trim())) {
        return false;
    }

    const possuiParentescoSelecionado = dependentes.filter(dependente => dependente['GrauParentesco.Grau'].trim() === parentesco.trim());

    if (!possuiParentescoSelecionado.length) {
        return false;
    }

    if (parentesco.trim() === '15') {
        return possuiParentescoSelecionado.length === 2;
    }

    if (parentesco.trim() === 'AVô') {
        return possuiParentescoSelecionado.length === 4;
    }

    if (seq) {
        return seq !== possuiParentescoSelecionado[0].Seq;
    }

    return true;
};

export const validatorParentescoEmDuplicidade = (valoresForm, dependentes) => {
    const arrayDeValidacoes = [
        verificaSeJaPossuiParentescoSelecionado(dependentes, valoresForm)
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

const parentescos = {
    '01': 'PAI',
    '20008': 'PADRASTO',
    '02': 'MAE',
    '20007': 'MADRASTA',
    '10': 'ESPOSO(A)',
    '32': 'EX-CONJUGE',
    '15': 'SOGRO(A)',
    '5': 'FILHO(A)',
    '50': 'FILHO(A) ADOTIVO',
    '03': 'IRMA(O)',
    '07': 'SOBRINHO(A)',
    '10006': 'ENTEADO(A)',
    '10016': 'OUTROS',
    '12': 'NETO(A)',
    '22': 'PRIMO(A)',
    '19': 'GENRO',
    '20': 'NORA',
    '24': 'TIO(A)',
    'AVô': 'AVO',
    'PET': 'PET (ANIMAL)'
};

export const retornaLabelDoValorParentesco = valueParentesco => {
    const parentesco = valueParentesco.trim();

    if (parentesco === '15') {
        return `Só é permitido dois dependentes do tipo  ${parentescos[`${parentesco}`]}`;
    }

    if (parentesco === 'AVô') {
        return `Só é permitido quatro dependentes do tipo  ${parentescos[`${parentesco}`]}`;
    }

    if (parentesco === 'PET') {
        return '';
    }

    return `Só é permitido um dependente do tipo  ${parentescos[`${parentesco}`]}`;
};

export const verificaConflitoRegrasPaisPadastros = (dependentes, valorForm) => {
    const parentescosValidar = ['02', '20007', '20008', '01'];
    let temMae = false;
    let temMadrasta = false;
    let temPadastro = false;
    let temPai = false;
    const parentescoSelecionado = valorForm.Parentesco;

    if (parentescoSelecionado) {
        for (const dep of dependentes) {
            if (dep.Seq === valorForm.Seq) { continue; }

            const grauParentesco = dep['GrauParentesco.Grau'];

            switch (grauParentesco?.trim()) {
                case '02':
                    temMae = true;
                    break;
                case '20007':
                    temMadrasta = true;
                    break;
                case '20008':
                    temPadastro = true;
                    break;
                case '01':
                    temPai = true;
                    break;
            }
        }

        if (parentescosValidar.includes(parentescoSelecionado)) {
            if ((parentescoSelecionado === '02' && temMadrasta) || (parentescoSelecionado === '20007' && temMae)) {
                return 'Não é permitido ter MÃE e MADRASTA no mesmo plano.';
            }

            if ((parentescoSelecionado === '01' && temPadastro) || (parentescoSelecionado === '20008' && temPai)) {
                return 'Não é permitido ter PAI e PADASTRO no mesmo plano.';
            }
        }
    }

    return;
};
